import Pagination from './Pagination';

export interface RawPagination {
	currentPage: number;
	perPage: number;
	total: number;
	totalPages: number;
}

export default function mapPagination(pagination: RawPagination): Pagination {
	return new Pagination(pagination.currentPage, pagination.perPage, pagination.total, pagination.totalPages);
}
